import script from "./dpointsSettle.vue?vue&type=script&setup=true&lang=js"
export * from "./dpointsSettle.vue?vue&type=script&setup=true&lang=js"

import "./dpointsSettle.vue?vue&type=style&index=0&id=70903d28&lang=scss"

const __exports__ = script;

export default __exports__